<script>
export default {
  name: "house-svg"
}
</script>

<template>
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.9564 7.26676C16.2343 7.51691 16.2621 7.93382 16.0398 8.21175C15.7896 8.48969 15.3727 8.51749 15.0948 8.29514L14.4277 7.71146V12.8811C14.4277 14.1318 13.4271 15.1046 12.2042 15.1046H4.19957C2.94885 15.1046 1.97606 14.1318 1.97606 12.8811V7.71146L1.28121 8.29514C1.00327 8.51749 0.586367 8.48969 0.336222 8.21175C0.113871 7.93382 0.141665 7.51691 0.419604 7.26676L7.75718 1.04094C8.00733 0.84638 8.36865 0.84638 8.61879 1.04094L15.9564 7.26676ZM4.19957 13.7705H5.53367V9.54586C5.53367 8.93439 6.00617 8.4341 6.64543 8.4341H9.75834C10.3698 8.4341 10.8701 8.93439 10.8701 9.54586V13.7705H12.2042C12.6767 13.7705 13.0936 13.3814 13.0936 12.8811V6.57192L8.20189 2.43063L3.31017 6.57192V12.8811C3.31017 13.3814 3.69928 13.7705 4.19957 13.7705ZM6.86778 13.7705H9.53599V9.76821H6.86778V13.7705Z" fill="#868C95"/>
  </svg>
</template>

<style scoped>

</style>
